export const environment = {
  development: true,
  graphqlEndpoint: 'https://wasserzaehler-backend.dev.aks.euv-stadtbetrieb.de/intern/graphql',
  azure: {
    authority: 'https://login.microsoftonline.com/c39de00a-b33d-48a1-b0ad-27ce9f5a89b6',
    clientId: '81da00ca-79ba-447c-9b46-c4037e4f9c71',
    redirectUri: '/auth-callback',
    api_scopes: ['api://694fae48-fad6-49a9-9f31-eef1b342e8f4/User.Intern'],
  },
};
